import { Client, ExprArg, Index, Match, Paginate } from "faunadb";
import { AuthState } from "../context/AuthState";
import { PaginatedResponse } from "../Types";
import { getByIndexes, IndexSearch, q } from "./common";
import { getUserReferencebyUserId } from "./user";

export async function getMonstersCollected(client: Client, userId: string, paginateOptions?: any): Promise<PaginatedResponse<any>> {
  const userReference = await getUserReferencebyUserId(client, userId);
  const response = await client.query(
    q.Map(q.Paginate(q.Match(q.Index("monster_by_user2"), userReference), paginateOptions), q.Lambda(["ref"], q.Get(q.Var("ref"))))
  );
  // Isn't this the same as returning response with a cast?
  return {
    data: response["data"],
    after: response["after"],
    before: response["before"],
  };
}

export async function getMonstersPublished(
  client: Client,
  publishedMonsterOptions: PublishedMonstersOptions,
  paginateOptions: any
): Promise<PaginatedResponse<any>> {
  const [name, powerLevels, tags] = [publishedMonsterOptions.name, publishedMonsterOptions.powerLevel, publishedMonsterOptions.tags];
  const indexSearches: IndexSearch[] = [];
  const indexMain = "monsters_by_is_published_priority_sort";
  const indexByName = "monsters_by_name_priority_sort";
  const indexByPowerLevel = "monsters_by_power_level_priority_sort";
  const indexByTag = "monsters_by_tag_priority_sort";

  indexSearches.push({ index: indexMain, value: true });
  if (name && name !== "") {
    indexSearches.push({ index: indexByName, value: name });
  }
  if (powerLevels && powerLevels.length > 0) {
    indexSearches.push({ index: indexByPowerLevel, value: powerLevels, anyMatch: true });
  }
  if (tags && tags.length > 0) {
    indexSearches.push({ index: indexByTag, value: tags, anyMatch: false });
  }

  return await getByIndexes(client, indexSearches, paginateOptions);
}

export async function getMonsterNamesPublished(client: Client): Promise<PaginatedResponse<string>> {
  return await client.query(Paginate(Match(Index("monsters_names_by_is_published"), true), { size: 100000 }));
}

export async function getMonsterNamesSaved(client: Client, authState: AuthState): Promise<PaginatedResponse<string>> {
  const userRef = await getUserReferencebyUserId(client, authState.id!);
  return await client.query(Paginate(Match(Index("monster_names_by_user"), userRef)));
}

export interface PublishedMonstersOptions {
  name?: string;
  powerLevel?: string[];
  tags?: string[];
  username?: string;
}
